import apiService from '../../services/api';

// Init state
const state = {
    users: [],
    user: {},
    functions: [],
    usersByGroup: [],
    listAudits: []
};

// Getters
const getters = {};

// Actions
const actions = {
    getListUsers: (context, params) => {
        return apiService.get('user.index', params).then(response => {
            context.commit('GET_LIST_USERS', response);
        });
    },
    getUserInfo: (context, params) => {
        return apiService.get('user.detail', params).then(response => {
            context.commit('GET_USER_INFO_SUCCESS', response);
        });
    },
    deleteUserById: (context, params) => {
        return apiService.delete('user.detail', params).then(response => {
            context.commit('DELETE_USER_BY_ID_SUCCESS', params);
        });
    },
    createNewUser: (context, params) => {
        return apiService.post('user.index', params).then(response => {
            context.commit('ADD_NEW_USER_SUCCESS', response);
        });
    },
    updateUserInfo: (context, params) => {
        return apiService.put('user.detail', params);
    },
    requestConfirmPhone: (context, params) => {
        return apiService.post('user.requestConfirmPhone', params);
    },
    confirmPhone: (context, params) => {
        return apiService.post('user.confirmPhone', params);
    },
    getAllAudits: (context, params) => {
        return apiService.get('user.audit', params).then(response => {
            context.commit('GET_ALL_AUDITS_SUCCESS', response);
        });
    },
    createAuditByUser: (context, params) => {
        return apiService.post('user.audit', params);
    },
    getAllFunctions: (context, params) => {
        return apiService.get('user.functions', params).then(response => {
            context.commit('GET_ALL_FUNCTIONS_SUCCESS', response);
        });
    },
};

// Mutation
const mutations = {
    GET_LIST_USERS(state, users) {
        state.users = users;
    },
    GET_LIST_USERS_BY_GROUP_ID(state, data) {
        state.usersByGroup = data;
    },
    GET_ALL_FUNCTIONS_SUCCESS(state, functions) {
        state.functions = functions;
    },
    GET_USER_INFO_SUCCESS(state, user) {
        state.user = user;
    },
    ADD_NEW_USER_SUCCESS(state, user) {
        state.users.push(user);
    },
    DELETE_USER_BY_ID_SUCCESS(state, params) {
        function findUserIndex(element) {
            return element.id === params.id;
        }
        const index = state.users.findIndex(findUserIndex);
        state.users.splice(index, 1);
    },
    GET_ALL_AUDITS_SUCCESS(state, data) {
        state.listAudits = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
